'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Link(label, target) {
  this.hx = null;
  this.hy = null;
  this.hx = label;
  this.hy = target;
}
export { $c_Lio_intela_sites_intelacloud_content_Link as $c_Lio_intela_sites_intelacloud_content_Link };
$p = $c_Lio_intela_sites_intelacloud_content_Link.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Link;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Link() {
}
export { $h_Lio_intela_sites_intelacloud_content_Link as $h_Lio_intela_sites_intelacloud_content_Link };
$h_Lio_intela_sites_intelacloud_content_Link.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 1071493958, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Link)) {
    if ((this.hx === x$0.hx)) {
      var x = this.hy;
      var x$2 = x$0.hy;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Link";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.hx;
  }
  if ((n === 1)) {
    return this.hy;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bz)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Link as $isArrayOf_Lio_intela_sites_intelacloud_content_Link };
var $d_Lio_intela_sites_intelacloud_content_Link = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Link, "io.intela.sites.intelacloud.content.Link", ({
  bz: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Link as $d_Lio_intela_sites_intelacloud_content_Link };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Link.js.map
